export const COMMON_REQ = 'cris/viewReport/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/viewReport/COMMON_REQ_FAIL';

export const LOAD_VIEW_REPORT_REQ_SUCCESS = 'cris/viewReport/LOAD_VIEW_REPORT_REQ_SUCCESS';

const initialState = {
	isLoading: false,
	error: null,
	workOrderList: [],
	businessUnitList: [],
	businessUnitLocationList: [],
	customerList: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_VIEW_REPORT_REQ_SUCCESS: {
			const data = action.payload.data;
			return {
				...state,
				isLoading: false,
				workOrderList: data.work_orders
					? data.work_orders.map((item) => ({
						value: item.id,
						label: item.old_code ? item.code + ' -- ' + item.old_code : item.code
					}))
					: state.workOrderList,
				businessUnitList: data.business_units
					? data.business_units.map((item) => ({ value: item.id, label: item.name }))
					: state.businessUnitList,
				businessUnitLocationList: data.business_unit_locations
					? data.business_unit_locations.map((item) => ({ value: item.id, label: item.name, business_unit_id: item.business_unit_id }))
					: state.businessUnitLocationList,
				customerList: data.customers
					? data.customers.map((item) => ({ value: item.id, label: item.name }))
					: state.customerList,
			};
		}

		default:
			return state;
	}
}
